<template>
  <div class="mt-3">

    <v-row>
      <v-col cols="12" lg="6" class="d-flex flex-column">
        <v-card class="rounded-lg shadow flex d-flex flex-column">
          <v-card-title>
            Points cumulés par wilaya – Tableau
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="table"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <v-data-table class="rounded-lg table-border"
                          :headers="headers"
                          :items="wilayas"
                          :items-per-page="5"
            >
              <template v-slot:item.name="{ item }">
                <span class="text-no-wrap">{{ item.wilaya_name }}</span>
              </template>
              <template v-slot:item.accumulated_points="{ item }">
                <span class="font-weight-medium">
                  {{ CurrencyFormatting(item.accumulated_points) }}
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6" class="d-flex flex-column">
        <v-card tile
                class="shadow flex d-flex flex-column"
                :class="fullscreen ?  'fullscreen-card': 'rounded-lg'"
        >
          <v-card-title>
            Points cumulés par wilaya – Carte
            <v-spacer/>
            <v-btn icon @click="fullscreen = !fullscreen">
              <v-icon>{{ fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="image,article"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <DZSVG2 :wilayas="wilayas"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import DZSVG2 from "@/views/opus/dashboard/components/DZSVG2";

export default {
  props: ['opus_campaign_id'],
  components: {
    DZSVG2
  },
  data() {
    return {
      fullscreen: false,
      isLoading: false,
      headers: [
        {text: 'Wilaya', value: 'wilaya_name'},
        {text: 'Points cumulés', value: 'accumulated_points'},
      ],
      wilayas: [],
    }
  },
  methods: {
    pointsByWilaya() {
      this.isLoading = true
      if (!this.opus_campaign_id) return;
      HTTP.get('/v1/opus/dashboard/points-by-wilaya', {
        params: {
          opus_campaign_id: this.opus_campaign_id
        }
      }).then(res => {
        this.isLoading = false
        this.wilayas = res.data.data
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  created() {
    this.pointsByWilaya()
  },
  watch: {
    opus_campaign_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pointsByWilaya();
      }
    }
  }
}
</script>

<style>
.fullscreen-card {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background-color: white;
  overflow: auto;
}
</style>